import { APIMethod, fetchData } from "@client";

export async function initLibraryQuery() {
  await fetchData("/v1/library/init", APIMethod.POST);
}
